import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Profile } from '../../modules/player/profile';
import { GameLaunchURLs } from '../../modules/player/gameLaunchURLs';
import { environment } from '../../../../environments/environment';
import { LoginService } from '../login/login.service';
import { TournamentsList } from '../../modules/player/tournamentsList';
import { Stats } from '../../modules/player/stats';
import { GameHistoryData } from '../../modules/gamehistory';
import { RemoteGamesHistory } from '../../modules/remotegamehistory/remotegamehistory';
import { Observable } from 'rxjs';

function launchFlashLobby(params: object) {
  let authWindow = window.open('about:blank', '', 'left=20,top=20,width=800,height=600,toolbar=0,resizable=1');
  if (authWindow) {
    authWindow.location.replace("/lobby/lobbyflash.html");
    authWindow.sessionStorage.setItem("flashgamelaunch", JSON.stringify(params));
  }
}

@Injectable({
  providedIn: 'root'
})
export class PlayerService {

  constructor(private httpClient: HttpClient,) { }
  httpBeforLoginOptions() {
    let Options = {

      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'siteid': environment.skinId
      })
    }
    return Options
  };

  httpOptions() {
    let options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'siteid': environment.skinId,
        'wsession': sessionStorage.getItem('wsessionBD') || ''
      })
    };
    return options;
  }

  onPlayerGetProfile() {
    return this.httpClient.post<Profile>(`${environment.api.baseUrl}${environment.api.player.getProfile}`, {}, this.httpOptions());
  }
  onPlayerUpdateProfile(postData: Object): Observable<Profile> {
    return this.httpClient.post<Profile>(`${environment.api.baseUrl}${environment.api.player.updateProfile}`, postData, this.httpOptions());
  }
  onPlayerUpdatePassword(postData: Object): Observable<Profile> {
    return this.httpClient.post<Profile>(`${environment.api.baseUrl}${environment.api.player.updatePassword}`, postData, this.httpOptions());
  }
  onPlayerGetLaunchURLs() {
    return this.httpClient.post<GameLaunchURLs>(`${environment.api.baseUrl}${environment.api.player.getLaunchURLS}`, {}, this.httpOptions());
  }

  onPlayerGetGameHistory(postdata: Object) {
    return this.httpClient.post<GameHistoryData>(`${environment.api.baseUrl}${environment.api.history.game}`, postdata, this.httpOptions());
  }
  onPlayerGetTournamentsList(postdata: Object) {
    return this.httpClient.post<TournamentsList>(`${environment.api.baseUrl}${environment.api.player.tournamentsList}`, postdata, this.httpBeforLoginOptions());
  }

  onPlayerGetStats() {
    return this.httpClient.post<Stats>(`${environment.api.baseUrl}${environment.api.player.playerStats}`, {}, this.httpBeforLoginOptions());
  }

  onPlayerGetPlayerLevels() {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.player.playerLevels}`, {}, this.httpOptions());
  }
  onplayerBonuswager() {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.player.playerBonuswager}`,{}, this.httpOptions());
  }

  onPlayerLeaderBoardList() {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.leaderboardList}`, {}, this.httpOptions());
  }
  onPlayerLeaderBoardGetParticipants() {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.getParticipants}`, {}, this.httpOptions());
  }
  onPlayerGetRemoteGameHistory(postdata: Object) {
    return this.httpClient.post<RemoteGamesHistory>(`${environment.api.baseUrl}${environment.api.history.remotegame}`, postdata, this.httpOptions());
  }

  getExchangeRates() {
    return this.httpClient.post<any>(`${environment.api.baseUrl}${environment.api.player.exchangeRates}`, {}, this.httpOptions());
  }

  onExchange(payload: any) {
    return this.httpClient.post<any>(`${environment.api.baseUrl}${environment.api.player.exchange}`, payload, this.httpOptions());
  }
  Kagaming(payload: any) {
    return this.httpClient.post<any>(`${environment.api.baseUrl}${environment.api.kagame}`, payload, this.httpOptions());
  }

  makeExchange(exchangeInfo: { amount: number; targetAmount: string; cpExchangeType: string; selectedWalletType: string; }) {
    return this.httpClient.post<any>(`${environment.api.baseUrl}${environment.api.player.exchangeVipPointsUrl}`, exchangeInfo, this.httpOptions());
  }

  // ============================= Avatar API =============================
  onGetAvtarList() {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.getAvatarList}`, {}, this.httpOptions());
  }
  onGetAvtar() {
    return this.httpClient.get<any>(`${environment.api.baseUrl}${environment.api.getAvatar}`, {});
  }
  // ============================= Avatar API =============================


  launchFlashGame(value: GameLaunchURLs) {
    let params = {
      serverUrls: [] as string[],
      sessionID: "",
      clientType: "",
      LANG: "",
      swf2load: ""
    };

    value.connections.forEach(connection => {
      params.serverUrls.push(connection.uri);
    });

    const session = sessionStorage.getItem('wsessionBD') || '';
    params.sessionID = session.split(".")[1] || '';
    params.clientType = "POKER_LOBBY";
    params.LANG = "en";
    params.swf2load = "flashloader";

    launchFlashLobby(params);
  }
  interKassaWithDra(body: { paymentMethod: string; amount: any; ifsc?: any; accountType: any; personalNumber: any; bankName: any; nameOnAccount: any; address?: any; city?: any; state?: any; zip?: any; phone: any; }) {
    return this.httpClient.post<any>(`${environment.api.cashier.interKassaCashOut}`, body, this.httpOptions());

  }
  public getlivedealer() {
    // let wsession = sessionStorage.getItem("wsession");
    return this.httpClient.get<any>(`${environment.api.baseUrl}${environment.api.livedealer}`, this.httpOptions());
  }
  public getlivedealergames() {
    // let wsession = sessionStorage.getItem("wsession");
    // return this.httpClient.get<any>(`${environment.api.baseUrl}${environment.api.livedealer}}`,body,this.httpOptions() );
    return this.httpClient.get(`${environment.api.baseUrl}${environment.api.livedealer}`, this.httpOptions());
  }

  getCaptchaLoginURL() {
    // let wsession = sessionStorage.getItem("wsession");
    // return this.httpClient.get<any>(`${environment.api.baseUrl}${environment.api.livedealer}}`,body,this.httpOptions() );
    return this.httpClient.get(`${environment.api.baseUrl}${environment.api.player.captchaAuth}`, this.httpOptions());
  }

  getPlayerStatistics() {
    return this.httpClient.get(`${environment.api.baseUrl}${environment.api.player.playerStatistics}`, this.httpOptions());
  }

  generateTokenClanApi() {
    return this.httpClient.post<any>(`${environment.api.baseUrl}${environment.api.generateTokenClan}`, {}, this.httpOptions());
  }

  getRandom(api: keyof typeof environment.api): Observable<any> {
    const url = `${environment.api.baseUrl}${environment.api[api]}`;
    return this.httpClient.get(url, this.httpOptions());
  }

  lottery(gameId: any) {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.lottery}`, gameId, this.httpOptions());
  }

  onLaunch18PeachesGame(gameId: any) {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.launchGame}`, gameId, this.httpOptions());
  }
  onLaunchJilliGames(gameId: any) {
    return this.httpClient.post(`${environment.api.baseUrl}${environment.api.launchJill}`, gameId, this.httpOptions());
  }

} 
